import * as React from 'react';

function BilanIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_35202_116345)">
        <path
          d="M15.9467 5.07333C15.9133 4.99333 15.86 4.92 15.8 4.86L11.0467 0.193333C11.0467 0.193333 10.98 0.153333 10.9467 0.126667C10.9067 0.1 10.8733 0.0666667 10.8333 0.0533333C10.7533 0.02 10.6667 0 10.58 0H5.33333C4.96667 0 4.66667 0.3 4.66667 0.666667V2.66667H0.666667C0.3 2.66667 0 2.96667 0 3.33333V15.3333C0 15.7 0.3 16 0.666667 16H10.6667C11.0333 16 11.3333 15.7 11.3333 15.3333V13.3333H15.3333C15.7 13.3333 16 13.0333 16 12.6667V5.33333C16 5.24667 15.98 5.15333 15.9467 5.07333ZM11.2467 2.25333L13.7067 4.66667H11.2467V2.25333ZM9.04 7.33333H6.58V4.92L9.04 7.33333ZM1.33333 14.6667V4H5.24667V8C5.24667 8.36667 5.54667 8.66667 5.91333 8.66667H10V14.6667H1.33333ZM11.3333 12V8C11.3333 7.91333 11.3133 7.82 11.28 7.74C11.2467 7.66 11.1933 7.58667 11.1333 7.52667L6.38 2.86C6.38 2.86 6.31333 2.82 6.28 2.79333C6.24 2.76667 6.20667 2.73333 6.16667 2.72C6.11333 2.7 6.05333 2.69333 5.99333 2.68667V2.67333V1.33333H9.90667V5.33333C9.90667 5.7 10.2067 6 10.5733 6H14.66V12H11.3267H11.3333Z"
          fill="#CFD4DA"
        />
      </g>
      <defs>
        <clipPath id="clip0_35202_116345">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

const MemoBilanIcon = React.memo(BilanIcon);
export default MemoBilanIcon;
